module.exports = __webpack_public_path__ + "media/images/email-11a10a7c.svg";